import { Directive, inject, Input, ViewContainerRef } from '@angular/core';
import { Calendar } from 'primeng/calendar';
import { UiFormItemDirective } from './ui-form-item.directive';
import { TimeConstraintCalendarFooterComponent } from './time-constraint-calendar-footer.component';
import { UiCalendarDirective } from './ui-calendar.directive';

@Directive({
    standalone: true,
    selector: '[timeConstraintCalendar]',
})
export class TimeConstraintCalendarDirective extends UiCalendarDirective {

    @Input({ required: true }) pageCode: string;
    @Input({ alias: 'timeConstraintCalendar', required: true }) controlName: string;


    constructor(primeNgCalendar: Calendar) {
        super(primeNgCalendar)

        const viewRef = inject(ViewContainerRef);

        const calendarFooter = viewRef.createComponent(TimeConstraintCalendarFooterComponent).instance;
        calendarFooter.calendarComponent = primeNgCalendar;
        primeNgCalendar.footerTemplate = calendarFooter.templateRef;
    }

}
